import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_GoodsReceiptProcess } from "./SIV_GoodsReceiptProcess";
import type { SIV_GoodsReceivingItem } from "./SIV_GoodsReceivingItem";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_GoodsReceiptProcessPositionAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  blockingIndicator?: string | undefined;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  countryOfOrigin?: string | undefined;
  deliveryNoteQuantity?: number | undefined;
  dimensions?: string | undefined;
  goodsReceiptProcess: SIV_GoodsReceiptProcess;
  goodsReceivingItem?: SIV_GoodsReceivingItem | undefined;
  notes?: string | undefined;
  notFoundValues: any;
  orderNumber?: string | undefined;
  orderPosition?: string | undefined;
  packagingType?: string | undefined;
  packedQuantity?: number | undefined;
  partNo?: string | undefined;
  plannedQuantity?: number | undefined;
  positionNo: number;
  productNo?: string | undefined;
  quantity?: number | undefined;
  receivedQuantity?: number | undefined;
  storageLocation?: string | undefined;
  tenant?: OD3_Tenant | undefined;
  unit?: string | undefined;
  weight?: number | undefined;
}

export class SIV_GoodsReceiptProcessPosition extends Parse.Object<SIV_GoodsReceiptProcessPositionAttributes> {
  static className: string = "SIV_GoodsReceiptProcessPosition";

  constructor(data?: Partial<SIV_GoodsReceiptProcessPositionAttributes>) {
    super(
      "SIV_GoodsReceiptProcessPosition",
      data as SIV_GoodsReceiptProcessPositionAttributes,
    );
  }

  get blockingIndicator(): string | undefined {
    return super.get("blockingIndicator");
  }
  set blockingIndicator(value: string | undefined) {
    super.set("blockingIndicator", value);
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get countryOfOrigin(): string | undefined {
    return super.get("countryOfOrigin");
  }
  set countryOfOrigin(value: string | undefined) {
    super.set("countryOfOrigin", value);
  }

  get deliveryNoteQuantity(): number | undefined {
    return super.get("deliveryNoteQuantity");
  }
  set deliveryNoteQuantity(value: number | undefined) {
    super.set("deliveryNoteQuantity", value);
  }

  get dimensions(): string | undefined {
    return super.get("dimensions");
  }
  set dimensions(value: string | undefined) {
    super.set("dimensions", value);
  }

  get goodsReceiptProcess(): SIV_GoodsReceiptProcess {
    return super.get("goodsReceiptProcess");
  }
  set goodsReceiptProcess(value: SIV_GoodsReceiptProcess) {
    super.set("goodsReceiptProcess", value);
  }

  get goodsReceivingItem(): SIV_GoodsReceivingItem | undefined {
    return super.get("goodsReceivingItem");
  }
  set goodsReceivingItem(value: SIV_GoodsReceivingItem | undefined) {
    super.set("goodsReceivingItem", value);
  }

  get notes(): string | undefined {
    return super.get("notes");
  }
  set notes(value: string | undefined) {
    super.set("notes", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get orderNumber(): string | undefined {
    return super.get("orderNumber");
  }
  set orderNumber(value: string | undefined) {
    super.set("orderNumber", value);
  }

  get orderPosition(): string | undefined {
    return super.get("orderPosition");
  }
  set orderPosition(value: string | undefined) {
    super.set("orderPosition", value);
  }

  get packagingType(): string | undefined {
    return super.get("packagingType");
  }
  set packagingType(value: string | undefined) {
    super.set("packagingType", value);
  }

  get packedQuantity(): number | undefined {
    return super.get("packedQuantity");
  }
  set packedQuantity(value: number | undefined) {
    super.set("packedQuantity", value);
  }

  get partNo(): string | undefined {
    return super.get("partNo");
  }
  set partNo(value: string | undefined) {
    super.set("partNo", value);
  }

  get plannedQuantity(): number | undefined {
    return super.get("plannedQuantity");
  }
  set plannedQuantity(value: number | undefined) {
    super.set("plannedQuantity", value);
  }

  get positionNo(): number {
    return super.get("positionNo");
  }
  set positionNo(value: number) {
    super.set("positionNo", value);
  }

  get productNo(): string | undefined {
    return super.get("productNo");
  }
  set productNo(value: string | undefined) {
    super.set("productNo", value);
  }

  get quantity(): number | undefined {
    return super.get("quantity");
  }
  set quantity(value: number | undefined) {
    super.set("quantity", value);
  }

  get receivedQuantity(): number | undefined {
    return super.get("receivedQuantity");
  }
  set receivedQuantity(value: number | undefined) {
    super.set("receivedQuantity", value);
  }

  get storageLocation(): string | undefined {
    return super.get("storageLocation");
  }
  set storageLocation(value: string | undefined) {
    super.set("storageLocation", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }

  get unit(): string | undefined {
    return super.get("unit");
  }
  set unit(value: string | undefined) {
    super.set("unit", value);
  }

  get weight(): number | undefined {
    return super.get("weight");
  }
  set weight(value: number | undefined) {
    super.set("weight", value);
  }
}

Parse.Object.registerSubclass(
  "SIV_GoodsReceiptProcessPosition",
  SIV_GoodsReceiptProcessPosition,
);
